import { applySnapshot, getSnapshot, types } from 'mobx-state-tree';
import { LoadingState, LoadingStates } from 'globals/types';
import { SingleEventsFeedItemDataProps } from 'components/UserPanel/Pages/Report/ReportBoxes/EventsFeed/SingleEventsFeedItem/SingleEventsFeedItem';
import {
  EventsFeedSingleItem,
  EventsFeedSingleItemProps,
} from './events-feed-single-item';

export interface EventsFeedProps {
  events: EventsFeedSingleItemProps[];
  status: LoadingState;
}

export const EventsFeed = types
  .model({
    events: types.optional(types.array(EventsFeedSingleItem), []),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: EventsFeedProps): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        ...props,
      };
      applySnapshot(self, newSnapshot);
    },
    updateStatus(status: LoadingState): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        status,
      };
      applySnapshot(self, newSnapshot);
    },
  }))
  .views((self) => ({
    eventsFeedList(): SingleEventsFeedItemDataProps[] {
      const { events } = self;
      return events.map(
        ({ displayAmount, displayDate, displayTags, ...otherProps }) => ({
          ...otherProps,
          amount: displayAmount(),
          date: displayDate(),
          tags: displayTags(),
        })
      );
    },
  }));
